import React, { useState } from 'react'
import { connect } from 'react-redux'
import {
  addMembersToBookingServicePermission,
  updateMembersToBookingServicePermission,
  postNotification,
} from '../../../../../../../../../../data/actions'
import { selectWaitingPermissions } from '../../../../../../../../../../data/selectors/tenantBookings'
import PermissionsSelector from '../components/PermissionsSelector/container'
import MemberItem from './components/MemberItem'
import { ProcessingIndicator } from '../../ProcessingIndicator'

const MembersDialog = ({
  onClose,
  members,
  nebulaMembers,
  postNotification,
  mode,
  service,
  booking,
  waitingPermissions,
  addMembersToBookingServicePermission,
  updateMembersToBookingServicePermission,
  loggedInPoPmDaimlerId,
}) => {
  const mappedMembers = members.map((member) => ({
    ...member,
    waitingMode: waitingPermissions.includes(member.daimlerId),
  }))
  const [permission, setPermission] = useState(null)
  const [selectedMembers, setSelectedMembers] = useState([])
  const [filter, setFilter] = useState('')
  const waitingMode = mappedMembers.find((member) => member.waitingMode)

  const onSelectPermission = (permission) => {
    if (
      permission?.providerOnly &&
      selectedMembers.some((member) => !nebulaMembers[member.daimlerId])
    ) {
      postNotification({
        message:
          'You cannot assign NEBULA_ONLY permission to non NEBULA tenant member',
        mode: 'error',
      })
    }
    setPermission(permission)
  }
  const onSelectMember = (member) => {
    const newMembers = [...selectedMembers]
    const currentMemberIndex = newMembers.findIndex(
      (mmbr) => mmbr.daimlerId === member.daimlerId,
    )
    if (currentMemberIndex > -1) {
      newMembers.splice(currentMemberIndex, 1)
      setSelectedMembers(newMembers)
    } else {
      newMembers.push(member)
      setSelectedMembers(newMembers)
    }
  }
  const generateDaimplerIdsList = (membersToSubmit) => {
    const daimlerIds = []
    for (let member of membersToSubmit) {
      if (!member.permission || member.permission?.id !== permission.id) {
        daimlerIds.push(member.daimlerId)
      }
    }
    return daimlerIds
  }
  const generateBookingPermissionsList = (mmbrs) => {
    const permissionIds = []
    for (let member of mmbrs) {
      if (member.permission && member.permission?.id !== permission.id) {
        permissionIds.push(member.permission.perm.id)
      }
    }
    return permissionIds
  }

  const onSubmit = () => {
    if (mode === 'edit') {
      if (members.length && permission) {
        const permissionIds = generateBookingPermissionsList(mappedMembers)
        permissionIds.length &&
          updateMembersToBookingServicePermission(
            booking,
            permissionIds,
            permission.slug,
            service,
            () => {
              onClose()
            },
          )
      }
    } else {
      if (selectedMembers.length && permission) {
        const daimplerIds = generateDaimplerIdsList(selectedMembers)
        daimplerIds.length &&
          addMembersToBookingServicePermission(
            daimplerIds,
            booking,
            permission,
            service,
            () => {
              setSelectedMembers([])
              onClose()
            },
          )
      }
    }
  }
  let membersHaveSamePermission = () => {
    const obj = {}
    selectedMembers.forEach((mmbr) => {
      obj[mmbr.permission ? mmbr.permission.id : 'np'] = true
    })
    return Object.keys(obj).length === 1
  }

  const filteredMembers = mappedMembers.filter((member) => {
    return `${member.firstName} ${member.lastName} ${member.email} ${member.daimlerId} ${member.mbioId}`
      .toLowerCase()
      .includes(filter.toLowerCase())
  })

  const saveButtonDisabled = () => {
    return (
      waitingMode ||
      !(
        permission &&
        (mode === 'edit'
          ? mappedMembers.length &&
            generateBookingPermissionsList(mappedMembers).length
          : selectedMembers.length)
      ) ||
      (permission.providerOnly &&
        selectedMembers.some((member) => !nebulaMembers[member.daimlerId]))
    )
  }

  return (
    <wb-modal
      mode={mode}
      close-on-backdrop-click
      close-on-escape-key
      scroll-lock
      active-level="1"
      id="membersDialog"
    >
      <wb-modal-level level="1">
        <wb-modal-header></wb-modal-header>
        <wb-modal-content
          headline={(mode === 'edit' ? 'Update' : 'Add') + ' members'}
        >
          <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
            <div className="wb-margin-bottom-xs">
              <wb-input-control>
                <wb-input>
                  <label>Search...</label>
                  <input
                    type="text"
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                  />
                </wb-input>
              </wb-input-control>
            </div>
            {filteredMembers.length ? (
              filteredMembers.map((member) => (
                <MemberItem
                  key={member.daimlerId}
                  member={member}
                  mode={mode}
                  loggedInPoPmDaimlerId={loggedInPoPmDaimlerId}
                  disabled={member.waitingMode}
                  checked={
                    selectedMembers.find(
                      (mmbr) => mmbr.daimlerId === member.daimlerId,
                    ) || false
                  }
                  onSelectMember={onSelectMember}
                />
              ))
            ) : (
              <div>No Members available</div>
            )}
          </div>

          <div className="wb-margin-top-l">
            <PermissionsSelector
              withHelp
              withEmptySelector
              service={service}
              booking={booking}
              members={mode === 'edit' ? mappedMembers : selectedMembers}
              currentPermission={
                membersHaveSamePermission()
                  ? selectedMembers[0].permission
                  : null
              }
              disabled={!Boolean(mappedMembers.length)}
              onSelect={onSelectPermission}
            />
          </div>
        </wb-modal-content>

        <wb-modal-footer>
          <button
            type="button"
            className="wb-button wb-button--secondary wb-button--large"
            onClick={onClose}
          >
            {waitingMode ? 'Close' : 'Cancel'}
          </button>
          <button
            type="button"
            onClick={onSubmit}
            disabled={saveButtonDisabled()}
            className="wb-button wb-button--primary wb-button--large"
          >
            {waitingMode ? <ProcessingIndicator withText /> : null}
            <div>{!waitingMode ? 'Save' : ''}</div>
          </button>
        </wb-modal-footer>
      </wb-modal-level>
    </wb-modal>
  )
}

export default connect(
  (
    { tenantBookings: { waitingPermissions }, tenants: { nebulaMembers } },
    ownProps,
  ) => ({
    waitingPermissions: selectWaitingPermissions(
      waitingPermissions,
      ownProps.booking.id,
      ownProps.service.slug,
    ),
    nebulaMembers,
  }),
  {
    addMembersToBookingServicePermission,
    updateMembersToBookingServicePermission,
    postNotification,
  },
)(MembersDialog)
